// extracted by mini-css-extract-plugin
module.exports = {"defaultHeight":"LabeledItem_defaultHeight__eyvq1","container":"LabeledItem_container__FH_EI","content":"LabeledItem_content__-jx40","error":"LabeledItem_error__2HlQM"};